import React from 'react';
import { Alert as MuiAlert } from '@mui/material';

const Alert = ({ type = 'error', message, onClose }) => {
  if (!message) return null;

  let bgColor, textColor, borderColor, iconColor;
  switch (type) {
    case 'error':
      bgColor = (theme) => theme.palette['error'].light;
      textColor = (theme) => theme.palette['error'].main;
      borderColor = (theme) => theme.palette['error'].main;
      iconColor = (theme) => theme.palette['error'].main;
      break;
    case 'success':
      bgColor = (theme) => theme.palette['success'].light;
      textColor = (theme) => theme.palette['success'].main;
      borderColor = (theme) => theme.palette['success'].dark;
      iconColor = (theme) => theme.palette['success'].main;
      break;
    case 'warning':
      bgColor = 'rgba(255, 244, 229, 0.9)';
      textColor = '#ed6c02';
      borderColor = '#ed6c02';
      iconColor = '#ed6c02';
      break;
    case 'info':
      bgColor = 'rgba(232, 244, 253, 0.9)';
      textColor = '#0288d1';
      borderColor = '#0288d1';
      iconColor = '#0288d1';
      break;
    default:
      bgColor = 'rgba(245, 245, 245, 0.9)';
      textColor = '#616161';
      borderColor = '#bdbdbd';
      iconColor = '#616161';
  }

  return (
    <MuiAlert
      severity={type}
      onClose={onClose}
      sx={{
        fontSize: '1rem',
        fontWeight: '500',
        borderRadius: '10px',
        textAlign: 'left',
        backgroundColor: bgColor,
        color: textColor,
        // border: `1px solid ${borderColor}`,
        '& .MuiAlert-icon': {
          color: iconColor,
        },
      }}
    >
      {message}
    </MuiAlert>
  );
};

export default Alert;
